import { forwardRef } from 'react';
import { createElement } from 'react';

const Wrapper = forwardRef(({ el, ...props }, ref) =>
  createElement(el, { ref, ...props })
);

export default Wrapper;
